<template>
  <strong :class="[`${situacaoClass}--text`, 'upperCase']">
    <slot>Vistoria {{ situacao }}</slot>
  </strong>
</template>

<script>
  export default {
    props: ['situacao'],
    computed: {
      situacaoClass () {
        switch (this.situacao) {
          case 'realizada':
            return 'primary'
          case 'atrasada':
            return 'vermelho'
          case 'próxima':
            return 'amarelo'
          case 'em dia':
            return 'verde'
        }
      }
    }
  }
</script>

<style scoped>
  .upperCase { text-transform: uppercase; }
</style>



// WEBPACK FOOTER //
// VistoriaSituacao.vue?58afd4a7